import React from 'react';
import { SxProps, Theme } from '@mui/material';
import Box from '../Box';
import {
  informationAlertHeader,
  informationAlertPaper,
  informationAlertWrapper,
} from './InformationAlert.style';
import Paper from '../Paper';
import Typography from '../Typography';
import { sxCombine } from '../utiles';

type InformationAlertProps = {
  children: React.ReactNode | React.ReactNode[];
  title?: string;
  sx?: SxProps<Theme>;
};
const InformationAlert = ({
  children,
  title = 'Information',
  sx,
}: InformationAlertProps) => (
  <Box sx={sxCombine(informationAlertWrapper, sx ?? false)}>
    <Paper sx={informationAlertPaper}>
      <Box sx={informationAlertHeader}>
        <span>!</span>
        <Typography variant="h4" component="p">
          {title}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Paper>
  </Box>
);

export default InformationAlert;
